import { render, staticRenderFns } from "./InvestigationReport.vue?vue&type=template&id=be59255c&scoped=true&"
import script from "./InvestigationReport.vue?vue&type=script&lang=js&"
export * from "./InvestigationReport.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationReport.vue?vue&type=style&index=0&id=be59255c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be59255c",
  null
  
)

export default component.exports